<script>
  import { fade, fly } from 'svelte/transition';
  
  let { message, type = 'info', duration = 3000 } = $props();
  let show = $state(true);
  
  $effect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        show = false;
      }, duration);
      
      return () => clearTimeout(timer);
    }
  });
  
  const typeStyles = {
    success: 'text-black border-green-500',
    error: 'text-black border-red-500',
    warning: 'text-black border-yellow-500',
    info: 'text-black border-brand-600'
  };
  
  const typeIcons = {
    success: `<svg class="h-5 w-5 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
    </svg>`,
    error: `<svg class="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
    </svg>`,
    warning: `<svg class="h-5 w-5 text-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
    </svg>`,
    info: `<svg class="h-5 w-5 text-brand-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
    </svg>`
  };
</script>

{#if show}
  <div
    class="fixed bottom-4 right-4 z-50"
    transition:fly={{ y: 20, duration: 300 }}
  >
    <div
      class="flex items-center p-4 mb-4 rounded-lg border bg-white/20 backdrop-blur-[10px] {typeStyles[type]} relative"
      transition:fade={{ duration: 200 }}
    >
      <div class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg">
        {@html typeIcons[type]}
      </div>
      <div class="ml-3 text-sm font-normal flex-1 pr-8">
        {message}
      </div>
      <button
        type="button"
        class="absolute top-1 right-1 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 inline-flex h-8 w-8 hover:bg-white/30 bg-white/20 backdrop-blur-[10px]"
        onclick={() => show = false}
      >
        <span class="sr-only">Close</span>
        <svg class="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
        </svg>
      </button>
    </div>
  </div>
{/if} 